import styles from "./RadioGroup.module.css"
import { useState } from "react";
import Input from "../input/Input";
import { InputType } from "../../../../enums";

function RadioGroup({ options, value, onChange }) {
    const [currentValue, setCurrentValue] = useState(value);
    return (
        <fieldset id="group" value={currentValue} onChange={onChange} className={styles.radioContainer}>
            {
                options.map((radioButton, index) => {
                    return <Input className={styles.input} name="group" labelText={radioButton} inputType={InputType.radio} value={radioButton} checked={radioButton === currentValue} key={index} onClick={() => setCurrentValue(radioButton)} />
                })
            }
        </fieldset>
    )
}

export default RadioGroup;